export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_13.77ec294d.jpg";